export const fieldLabels = {
    ru: {

        id: "ID",
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Email",
        password: "Пароль",
        desk_id: "Деск",
        role: "Роль",
        sale_status: "Сейл Статус",
        reten_status: "Ретен Статус",
        manager_id: "Менеджер",
        phone: "Телефон",
        created_at: "Зарегистрирован(от)",
        address: "Адрес",
        affiliator_id: "Аффилиатор",
        campaign: "Кампания",
        city: "Город",
        country: "Страна",
        created_by_admin_id: "Создан админом",
        created_by_affiliator_id: "Создан аффилиатором",
        extra_info: "Доп. инфо",
        geo: "Гео",
        second_phone: "Второй телефон",
        updated_at: "Обновлен(до)",
        ai_trading: "ИИ трейдинг статус",
        bank_liquidity: "Ликвидность банкa",
        bot_profit_percent: "Профит % ботов",
        trading_access_blocked: "Доступ к торговле",


        statusOptions: {
            all: 'Все',
            active: 'Активный',
            blocked: 'Заблокирован'
        },


        sort: {
            label: 'Сортировать по',
            idAsc: "ID (по возрастанию)",
            idDesc: "ID (по убыванию)",
            nameAsc: "Имя (по возрастанию)",
            nameDesc: "Имя (по убыванию)",
            saleStatusAsc: "Статус продажи (по возрастанию)",
            saleStatusDesc: "Статус продажи (по убыванию)",
            retenStatusAsc: "Статус удержания (по возрастанию)",
            retenStatusDesc: "Статус удержания (по убыванию)",
            managerNameAsc: "Имя менеджера (по возрастанию)",
            managerNameDesc: "Имя менеджера (по убыванию)",
            phoneAsc: "Телефон (по возрастанию)",
            phoneDesc: "Телефон (по убыванию)",
            emailAsc: "Email (по возрастанию)",
            emailDesc: "Email (по убыванию)",
            geoAsc: "Гео (по возрастанию)",
            geoDesc: "Гео (по убыванию)",
            lastCommentTextAsc: "Текст последнего комментария (по возрастанию)",
            lastCommentTextDesc: "Текст последнего комментария (по убыванию)",
            lastCommentDateAsc: "Дата последнего комментария (по возрастанию)",
            lastCommentDateDesc: "Дата последнего комментария (по убыванию)",
            registrationDateAsc: "Дата регистрации (по возрастанию)",
            registrationDateDesc: "Дата регистрации (по убыванию)",
            deskAsc: "Рабочий стол (по возрастанию)",
            deskDesc: "Рабочий стол (по убыванию)",
            affiliatorAsc: "Аффилиат (по возрастанию)",
            affiliatorDesc: "Аффилиат (по убыванию)",
            companyAsc: "Компания (по возрастанию)",
            companyDesc: "Компания (по убыванию)",
            depositSumAsc: "Сумма депозита (по возрастанию)",
            depositSumDesc: "Сумма депозита (по убыванию)",
            balanceAsc: "Баланс (по возрастанию)",
            balanceDesc: "Баланс (по убыванию)",
        },
    },
    en: {

        id: "ID",
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
        password: "Password",
        desk_id: "Desk",
        role: "Role",
        sale_status: "Sale Status",
        reten_status: "Reten Status",
        manager_id: "Manager",
        phone: "Phone",
        last_comment: "Last Comment",
        last_commented_at: "Last Comment Date",
        created_at: "Registered",
        address: "Address",
        affiliator_id: "Affiliator",
        campaign: "Campaign",
        city: "City",
        country: "Country",
        created_by_admin_id: "Created By Admin ID",
        created_by_affiliator_id: "Created By Affiliator ID",
        extra_info: "Extra Info",
        geo: "Geo",
        second_phone: "Second Phone",
        updated_at: "Updated At",
        ai_trading: "AI trading status",
        bank_liquidity: "Bank liquidity",
        bot_profit_percent: "Bot profit %",
        trading_access_blocked: "Trading Access",
        kyc_sales_name: "Name",
        kyc_sales_primary_citizenship: "Citizenship",
        kyc_sales_age: "Age",
        kyc_sales_profession: "Profession",
        kyc_sales_current_city_region: "City/Region",
        kyc_sales_previous_experience: "Experience",
        kyc_sales_has_savings: "Savings",
        kyc_sales_income: "Income",
        kyc_sales_marital_status: "Marital Status",
        kyc_sales_additional_comment: "Comment",
        kyc_retention_salary: "Salary",
        kyc_retention_salary_date: "Salary Date",
        kyc_retention_property: "Property",
        kyc_retention_marital_status: "Marital Status",
        kyc_retention_full_birth_date: "Birth Date",
        kyc_retention_needs: "Needs",
        kyc_retention_loans: "Loans",
        kyc_retention_residence: "Residence Registration",
        kyc_retention_car: "Car",
        kyc_retention_previous_experience: "Experience",
        kyc_retention_banks: "Banks",
        kyc_retention_fast_payments: "Fast Payments",
        kyc_retention_btc_wallet_revolut: "BTC/Revolut",


        statusOptions: {
            all: 'All',
            active: 'Active',
            blocked: 'Blocked'
        },


        sort: {
            label: 'Sort by',
            idAsc: "ID (ascending)",
            idDesc: "ID (descending)",
            nameAsc: "Name (ascending)",
            nameDesc: "Name (descending)",
            saleStatusAsc: "Sale Status (ascending)",
            saleStatusDesc: "Sale Status (descending)",
            retenStatusAsc: "Reten Status (ascending)",
            retenStatusDesc: "Reten Status (descending)",
            managerNameAsc: "Manager Name (ascending)",
            managerNameDesc: "Manager Name (descending)",
            phoneAsc: "Phone (ascending)",
            phoneDesc: "Phone (descending)",
            emailAsc: "Email (ascending)",
            emailDesc: "Email (descending)",
            geoAsc: "Geo (ascending)",
            geoDesc: "Geo (descending)",
            lastCommentTextAsc: "Last Comment Text (ascending)",
            lastCommentTextDesc: "Last Comment Text (descending)",
            lastCommentDateAsc: "Last Comment Date (ascending)",
            lastCommentDateDesc: "Last Comment Date (descending)",
            registrationDateAsc: "Registration Date (ascending)",
            registrationDateDesc: "Registration Date (descending)",
            deskAsc: "Desk (ascending)",
            deskDesc: "Desk (descending)",
            affiliatorAsc: "Affiliate (ascending)",
            affiliatorDesc: "Affiliate (descending)",
            companyAsc: "Company (ascending)",
            companyDesc: "Company (descending)",
            depositSumAsc: "Deposit Sum (ascending)",
            depositSumDesc: "Deposit Sum (descending)",
            balanceAsc: "Balance (ascending)",
            balanceDesc: "Balance (descending)",
        },
    },

};
